import React from 'react';
import styled from 'styled-components';
import { FiDownload } from 'react-icons/fi';

const FiDownloadIcon = FiDownload as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

const Button = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  background-color: ${({ theme }) =>
    theme ? theme.backgroundDark : '#ffffff'};
  color: white;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #444;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  width: 150px;
  min-width: 150px;
  height: 40px;
  &:hover {
    background-color: #333;
  }
`;

interface DownloadButtonProps {
  file: string;
  label?: string;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({
  file,
  label = 'Download CV',
}) => {
  return (
    <Button href={file} download="james-scott-cv.pdf">
      <FiDownloadIcon />
      {label}
    </Button>
  );
};

export default DownloadButton;
